import {useCallback, useContext, useEffect} from 'react';
import {PageContext} from '../../common/context';
import {getIsWebView} from '../../common/util/userAgent';

export default function useChangeWebviewTermsTitle(title?: string) {
  const {title: contextTitle} = useContext(PageContext);

  const sendTitleAndOpacity = useCallback(
    (opacity: number) => {
      if (getIsWebView()) {
        window.kakaowebtoonApp?.sendTitleAndOpacity?.(
          JSON.stringify({
            title: title || contextTitle,
            opacity,
            color: {light: '#f2f2f2', dark: '#121212'},
          })
        );
      }
    },
    [title, contextTitle]
  );

  useEffect(() => {
    sendTitleAndOpacity(1);
  }, [sendTitleAndOpacity]);

  return {sendTitleAndOpacity};
}
